import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { BsArrowUpRight } from 'react-icons/bs'
import Rating from '@mui/material/Rating'
import { Helmet } from 'react-helmet-async'
import Java from '../Image/Java.jpg'
import Python from '../Image/Python.jpg'
import Digital_Marketing_Marketing from '../Image/Digital_Marketing_Marketing.jpg'
import Full_Stack from '../Image/Full_Stack.jpg'
import Mern_Stack from '../Image/Mern_Stack.jpg'
import C_CPP_DSA from '../Image/C_CPP_DSA.jpg'

function Advance_program_page() {
  const courses = [
    {
      title: 'Java',
      description:
        'Take a thorough tour of Core Java and learn about basic ideas like classes, objects, packages...',
      imageUrl: Java,
      rating: 4,
      link: '/Java-Programming',
      alt: 'Java-Programming',
    },
    {
      title: 'Python',
      description:
        'Take a thorough look at Python and learn about data structures, advanced concepts, and...',
      imageUrl: Python,
      rating: 4,
      link: '/Python-Programming',
      alt: 'Python-Programming',
    },
    {
      title: 'Digital Marketing & Marketing',
      description:
        'With the help of our extensive Digital Marketing course, take a fascinating voyage into the...',
      imageUrl: Digital_Marketing_Marketing,
      rating: 4,
      link: '/Digital-Marketing-and-Marketing',
      alt: 'Digital-Marketing-and-Marketing',
    },
    {
      title: 'Full Stack Web Development',
      description:
        'Learn HTML, CSS, Bootstrap, SASS, JavaScript, DOM manipulation, jQuery, Node.js, SQL, React...',
      imageUrl: Full_Stack,
      rating: 4,
      link: '/Full-Stack-Web-Development',
      alt: 'Full-Stack-Web-Development',
    },
    {
      title: 'Mern Stack',
      description:
        'Take a look at the exciting field of web development with our in-depth MERN stack course...',
      imageUrl: Mern_Stack,
      rating: 4,
      link: '/Mern-Stack-Development',
      alt: 'Mern-Stack-Development',
    },
    {
      title: 'C, C++ with DSA',
      description:
        'Take a thorough look at Data Structures & Algorithms and C/C++ programming. This course...',
      imageUrl: C_CPP_DSA,
      rating: 4,
      link: '/C-CPP-DSA',
      alt: 'C-CPP-DSA',
    },
  ]
  const canonicalUrl = 'https://www.internselite.net/Advance-Program'
  return (
    <div>
      <Helmet>
        <title>
          Advance Program | InternsElite: Enhance Your Expertise with Advanced
          Training
        </title>
        <meta
          name="description"
          content="Take your skills to the next level with InternsElite’s Advance Program. Our specialized courses in Full Stack Web Development, Java, Python, and more provide in-depth knowledge and practical experience. Achieve professional growth, earn advanced certifications, and stay ahead in your career."
        />
        <meta
          name="keywords"
          content="advanced training, professional development, advanced courses, certification, career growth, skill enhancement"
        />
        <meta
          property="og:title"
          content="Advance Program | InternsElite: Enhance Your Expertise with Advanced Training"
        />
        <meta
          property="og:description"
          content="Take your skills to the next level with InternsElite’s Advance Program. Our specialized courses in Full Stack Web Development, Java, Python, and more provide in-depth knowledge and practical experience. Achieve professional growth, earn advanced certifications, and stay ahead in your career."
        />
        <meta
          property="og:url"
          content="https://internselite.net/advance-program"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta
          name="twitter:title"
          content="Advance Program | InternsElite: Enhance Your Expertise with Advanced Training"
        />
        <meta
          name="twitter:description"
          content="Take your skills to the next level with InternsElite’s Advance Program. Our specialized courses in Full Stack Web Development, Java, Python, and more provide in-depth knowledge and practical experience. Achieve professional growth, earn advanced certifications, and stay ahead in your career."
        />
        <meta
          name="twitter:image"
          content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png"
        />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      {/* -------------------Mobile View----------------------- */}
      <div className="Advance_program_image d-sm-block d-md-none mt-5">
        <div className="container-fluid Advance_background_color pt-4">
          <div className="text-center py-5 Mobile_Main_text">
            <h1 className="display-4  text-white">
              InternsElite Advance Program
            </h1>
            <h3 className="text-white fs-6 pt-2">
              Unleash your potential through our comprehensive programs,
              designed to propel your expertise to new heights{' '}
            </h3>
          </div>
        </div>
      </div>
      <div className="container pt-5 d-sm-block d-md-none">
        <div className="text-center About_Discraption_text">
          <h1 className="display-4">What’s in store for YOU ?</h1>
        </div>
        <div className="container pb-5">
        <div className="row">
          {courses.map((course, index) => (
            <div className="col-12 px-4" key={index}>
              <Link className="Program_card_link" to={course.link}>
                <div className="border pb-2 shadow Program_mobile_card">
                  <div>
                    <img
                      className="p-2"
                      src={course.imageUrl}
                      alt={course.title}
                    />
                  </div>
                  <div className="px-3">
                    <div className="row">
                      <div className="col-10">
                        <h1 className="pt-2">{course.title}</h1>
                      </div>
                      <div className="col-2">
                        <BsArrowUpRight className="text-end" />
                      </div>
                      <p className="pt-1">{course.description}</p>
                      </div>
                      <h6>
                      <b>Duration:</b> 3 Months 
                      </h6>
                      <h5 className="fw-normal pt-2">
                      4.5{' '}
                      <Rating
                        name="half-rating-read"
                        size="small"
                        defaultValue={5}
                        precision={4}
                        readOnly
                      />
                    </h5>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
        </div>
      </div>

      {/* ----------------------Desktop View------------------------- */}
      <div className="Advance_program_image d-none d-md-block mt-5">
        <div className="container-fluid Advance_background_color py-5">
          <div className="text-center pt-5 mt-5 Advance_Main_text">
            <h1 className="display-4 pt-5 text-white">
              InternsElite Advance Program
            </h1>
            <h3 className="text-white fs-4 pt-4 pb-5 mb-5">
              Unleash your potential through our comprehensive programs,
              designed to propel your expertise to new heights{' '}
            </h3>
          </div>
        </div>
      </div>
      {/* <div className="container pt-5 d-none d-xl-block">
        <div className="Container">
          <div className="text-center About_Discraption_text">
            <h1 className="display-4 pb-4">What’s in store for YOU ?</h1>
          </div>
        </div>
        <div className="container pb-5">
          <div className="row">
            {courses.map((course, index) => (
              <div className="col-md-3" key={index}>
                <Link className="Program_card_link" to={course.link}>
                  <div className="border shadow Program_card">
                    <div>
                      <img
                        className="p-2"
                        src={course.imageUrl}
                        alt={course.title}
                      />
                    </div>
                    <div className="px-4">
                      <h1 className="text-center pt-2">{course.title}</h1>
                      <p className="pt-1">{course.description}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      {/* ------------------Tab View-------------------- */}
      <div className="container pt-5 d-none d-md-block d-xl-none">
        <div className="Container">
          <div className="text-center About_Discraption_text">
            <h1 className="display-4 pb-4">What’s in store for YOU ?</h1>
          </div>
        </div>
        <div className="container pb-5">
        <div className="row">
          {courses.map((course, index) => (
            <div className="col-md-3" key={index}>
              <Link className="Program_card_link" to={course.link}>
                <div className="border shadow tab_Program_card pb-1">
                  <div>
                    <img
                      className="p-2"
                      src={course.imageUrl}
                      alt={course.title}
                    />
                  </div>
                  <div className="px-3 tab_Program_card">
                    <div className="row">
                      <div className="col-md-10">
                        <h1 className="">{course.title}</h1>
                      </div>
                      <div className="col-md-2">
                        <BsArrowUpRight className="text-end" />
                      </div>
                      <p className="pt-1">{course.description}</p>
                      </div>
                      <h6>
                      <b>Duration:</b> 3 Months
                      </h6>
                      <h5 className="fw-normal pt-2">
                      4.5{' '}
                      <Rating
                        name="half-rating-read"
                        size="small"
                        defaultValue={5}
                        precision={4}
                        readOnly
                      />
                    </h5>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
        </div>
      </div>
    </div>
  )
}

export default Advance_program_page
